import axios from "@/axios";
import { isPermissionType, PermissionType } from "@/Enums/PermissionType";

export const getPermissions = async (): Promise<PermissionType[]> => {
    const { data } = await axios.get("/api/permissions");

    const isListOfString = (data: any): data is string[] => {
        return Array.isArray(data) && data.every((item) => typeof item === "string");
    }

    if (!isListOfString(data)) return [];

    return data.filter(isPermissionType);
}